import { render, staticRenderFns } from "./page-settings.vue?vue&type=template&id=600c5dd7&scoped=true&"
import script from "./page-settings.vue?vue&type=script&lang=js&"
export * from "./page-settings.vue?vue&type=script&lang=js&"
import style0 from "./page-settings.vue?vue&type=style&index=0&id=600c5dd7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600c5dd7",
  null
  
)

export default component.exports